import { ROUTES } from '@/constants/routes'

export const TABS = {
  PROFILE: 'profile',
  SUBSCRIPTIONS: 'subscriptions',
  // PAYMENTS: 'payments',
} as const

export type TabItem = (typeof TABS)[keyof typeof TABS]

export type TTabsListItem = {
  label: string
  value: TabItem
  link: string
}

export const tabsList: TTabsListItem[] = [
  {
    label: 'Profile',
    value: TABS.PROFILE,
    link: ROUTES.PROFILE,
  },
  {
    label: 'Subscriptions',
    value: TABS.SUBSCRIPTIONS,
    link: ROUTES.SUBSCRIPTIONS,
  },
  // {
  //   label: 'Payments',
  //   value: TABS.SUBSCRIPTIONS,
  //   link: ROUTES.SUBSCRIPTIONS,
  // },
]
